export default "sale-badge.4b1d3062ffc836a7.png"